import PropTypes from 'prop-types';
import classNames from 'classnames';
import EmailOutlined from '@material-ui/icons/EmailOutlined';
import PhoneIphone from '@material-ui/icons/PhoneIphone';
import { getPhoneForDisplay } from 'util/phone';
import { SEND_TO_EMAIL, SEND_TO_SMS } from '../../consts';
import { colors, useOtpSendStyles } from '../otpSendTheme';

const selectKeys = ['Enter', ' ', 'Spacebar'];
const noop = () => null;

const DeliveryMethod = ({
  sendTo,
  onSendToChange,
  userInfo,
  canSendSms,
  canSendEmail,
}) => {
  const classes = useOtpSendStyles();

  const handleSelect = (value, disabled) => () => {
    if (!disabled) {
      onSendToChange(value);
    }
  };

  const handleKeyDown = (value, disabled) => (event) => {
    if (!disabled && selectKeys.includes(event.key)) {
      event.preventDefault();
      onSendToChange(value);
    }
  };

  const emailSelected = sendTo === SEND_TO_EMAIL;
  const smsSelected = sendTo === SEND_TO_SMS;

  return (
    <div aria-label="OTP delivery method" role="radiogroup">
      <div className={classes.subtitle}>
        Where would you like to send the OTP?
      </div>
      <div
        aria-checked={emailSelected}
        aria-disabled={!canSendEmail}
        className={classNames(classes.optionCard, {
          [classes.optionCardDisabled]: !canSendEmail,
          [classes.optionCardSelected]: emailSelected,
        })}
        onClick={handleSelect(SEND_TO_EMAIL, !canSendEmail)}
        onKeyDown={handleKeyDown(SEND_TO_EMAIL, !canSendEmail)}
        role="radio"
        tabIndex={canSendEmail ? 0 : -1}
      >
        <EmailOutlined style={{ color: colors.purplePrimary, fontSize: 20 }} />
        <div style={{ flex: 1 }}>
          <div className={classes.optionLabel}>Email</div>
          <div className={classes.optionValue}>{userInfo?.email}</div>
        </div>
        <div
          className={classNames(classes.radioOuter, {
            [classes.radioOuterSelected]: emailSelected,
          })}
        />
      </div>
      <div
        aria-checked={smsSelected}
        aria-disabled={!canSendSms}
        className={classNames(classes.optionCard, {
          [classes.optionCardDisabled]: !canSendSms,
          [classes.optionCardSelected]: smsSelected,
        })}
        onClick={handleSelect(SEND_TO_SMS, !canSendSms)}
        onKeyDown={handleKeyDown(SEND_TO_SMS, !canSendSms)}
        role="radio"
        tabIndex={canSendSms ? 0 : -1}
      >
        <PhoneIphone style={{ color: colors.purplePrimary, fontSize: 20 }} />
        <div style={{ flex: 1 }}>
          <div className={classes.optionLabel}>Mobile Phone</div>
          <div className={classes.optionValue}>
            {getPhoneForDisplay(userInfo?.mobilePhone)}
          </div>
        </div>
        <div
          className={classNames(classes.radioOuter, {
            [classes.radioOuterSelected]: smsSelected,
          })}
        />
      </div>
    </div>
  );
};

DeliveryMethod.propTypes = {
  canSendEmail: PropTypes.bool,
  canSendSms: PropTypes.bool,
  onSendToChange: PropTypes.func,
  sendTo: PropTypes.string,
  userInfo: PropTypes.shape({
    email: PropTypes.string,
    mobilePhone: PropTypes.string,
  }),
};

DeliveryMethod.defaultProps = {
  canSendEmail: false,
  canSendSms: false,
  onSendToChange: noop,
  sendTo: SEND_TO_SMS,
  userInfo: null,
};

export default DeliveryMethod;
